<script setup lang="ts">
import AnnouncementImage from './assets/announcement.png'

const props = defineProps<{
  modelValue: boolean
  title?: string
  description?: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value)
})

const handleClose = () => {
  show.value = false
}
</script>

<template>
  <el-drawer
    v-model="show"
    :with-header="false"
    direction="btt"
    size="auto"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="px-4">
      <div class="text-center">
        <img
          class="mx-auto px-12 mt-5"
          :src="AnnouncementImage"
          alt="Announcement illustration"
        />

        <div class="mid-text-h5 mt-4 font-bold text-center w-10/12 mx-auto">
          {{ title || 'Layanan Bright EV akan melakukan pemeliharaan sistem' }}
        </div>

        <div class="text-sm text-gray-600 mt-2 w-10/12 mx-auto">
          {{
            description ||
            'Mohon untuk tidak melakukan aktivitas sampai maintenance selesai, Terima kasih'
          }}
        </div>
      </div>

      <div class="mt-6 mb-4">
        <el-button class="w-full" type="primary" @click="handleClose"
          >Mengerti</el-button
        >
      </div>
    </div>
  </el-drawer>
</template>
